import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import UtilityFieldConfigService from "../services/utilityFieldConfig.service";

export const getColumnConfig = createAsyncThunk(
  "UtilityFieldConfig/get",
  async ({ implementor, forceSync }, thunkAPI) => {
    try {
      const data = await UtilityFieldConfigService.getColumnConfig(
        implementor,
        forceSync
      );
      return { config: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateColumnDescription = createAsyncThunk(
  "UtilityFieldConfig/update_description",
  async ({ implementor, field, description }, thunkAPI) => {
    try {
      const data = await UtilityFieldConfigService.updateColumnDescription({
        implementor,
        field,
        description,
      });
      return { column: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  config: null,
  loading: false,
  savingField: null,
};

const utilityFieldConfigSlice = createSlice({
  name: "utilityFieldConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getColumnConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(getColumnConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload.config;
      })
      .addCase(getColumnConfig.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateColumnDescription.pending, (state, action) => {
        state.savingField = action.meta.arg.field;
      })
      .addCase(updateColumnDescription.fulfilled, (state, action) => {
        state.savingField = null;
        const updated = action.payload.column;
        if (state.config?.columns && updated?.field) {
          const idx = state.config.columns.findIndex(
            (c) => c.field === updated.field
          );
          if (idx >= 0) {
            state.config.columns[idx] = updated;
          }
        }
      })
      .addCase(updateColumnDescription.rejected, (state) => {
        state.savingField = null;
      });
  },
});

export default utilityFieldConfigSlice.reducer;
